import { useEffect, useState } from "react"
import useStore from "../../../store"
import TransferPageBody from "../TransferPage/TransferPageBody"
import TransferHistoryBody from "./TransferHistoryBody"
import { useIsMobile } from "../../../hooks/useIsMobile"
import { useNavigate } from "react-router-dom"
import DashboardContainer from "../../common/DashboardContainer"
import TxnPageBody from "../TransferPage/TxnPageBody"

export default function TransferHistory() {
  const fetchPendingTransfers = useStore((state) => state.fetchPendingTransfers)
  const fetchProcessingTransfers = useStore((state) => state.fetchProcessingTransfers)
  const dealer = useStore((state) => state.dealer)
  const isMobile = useIsMobile()
  const navigate = useNavigate()
  const [selectedTransaction, setSelectedTransaction] = useState(null)

  useEffect(() => {
    fetchPendingTransfers()
    fetchProcessingTransfers()
  }, [dealer])

  const handleClick = (object) => {
    if (isMobile) {
      navigate(`/${object.type}/${object.id}`)
    } else {
      setSelectedTransaction(object)
    }
  }

  const sidePanelComponent = () => {
    switch(selectedTransaction?.type) {
      case 'transfers':
        return <TransferPageBody transferId={selectedTransaction?.id} shiftPill={true} />
      case 'txns':
        return <TxnPageBody txnId={selectedTransaction?.id} />
      default:
        return null
    }
  }

  const sidePanels = [
    {
      isExpanded: selectedTransaction,
      component: sidePanelComponent(),
      onClose: () => setSelectedTransaction(null),
      isFullscreenable: false,
    }
  ]

  return(
    <DashboardContainer sidePanels={sidePanels} >
      <TransferHistoryBody handleClick={handleClick} />
    </DashboardContainer>
  )
}